import React from "react";
import { FlexCenterTop, FlexRowSB } from "../../constant/CustomeStyle";
import Topbar from "../../constant/Topbar/Topbar";
import LeftMenu from "./LeftMenu";
import RightSection from "./RightSection";

const ReportLayout = ({ children }) => {
  return (
    <div style={{ background: "#E5E5E5" }}>
      <Topbar />

      <FlexRowSB>
        <LeftMenu />

        <FlexCenterTop>
          <div style={{ width: 710, marginTop: 27 }}>{children}</div>
        </FlexCenterTop>

        <RightSection />
      </FlexRowSB>
    </div>
  );
};

export default ReportLayout;
